export const ProspectActivityMediumTypeId = {
  Email: 1,
	SMS: 2,
  PP_Dashboard: 3,
  Plite: 4,
  Plug_and_Play: 5,
	PP_Engine: 6,
	OpenAgent: 7,
	OA_Assistant: 8
};
